import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';

export type MicrosoftResponse = {
  code: string;
};

const MicrosoftLoginRedirect = () => {
  const [searchParams] = useSearchParams();
  const [, setRedirect] = useCrossWindowState<MicrosoftResponse | null>(
    'microsoft-redirect',
    null,
  );

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      setRedirect({ code: code });
    }
  }, [searchParams, setRedirect]);

  return <></>;
};

export default MicrosoftLoginRedirect;
